"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var React = __importStar(require("react"));
var grid_1 = require("@rebass/grid");
var styled_components_1 = __importStar(require("styled-components"));
var marked_1 = __importDefault(require("marked"));
var MetroTileFunctions = __importStar(require("./MetroTile.functions"));
var Button_1 = require("../Button");
var MetroTileWrapper = styled_components_1["default"](grid_1.Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    overflow: hidden;\n    height: 50vh;\n    cursor: pointer;\n    ", "\n    ", ";\n    color: ", ";\n"], ["\n    position: relative;\n    overflow: hidden;\n    height: 50vh;\n    cursor: pointer;\n    ", "\n    ", ";\n    color: ", ";\n"])), MetroTileFunctions.GetPadding(), function (props) { return getBackgroundColor(props.backgroundColor, props.gradientColor); }, function (props) { return props.textColor; });
var getBackgroundColor = function (backgroundColor, gradientColor) {
    if (gradientColor) {
        return "background: linear-gradient(45deg, " + backgroundColor + ", " + gradientColor + ")";
    }
    return "background: " + backgroundColor;
};
// font-size: ${Spacing[4]};
var Text = styled_components_1["default"].div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    blockquote, a {\n        margin: 0;\n    }\n\n    @media ", "\n\n    @media ", "\n\n    @media ", "\n"], ["\n    blockquote, a {\n        margin: 0;\n    }\n\n    @media ",
    "\n\n    @media ",
    "\n\n    @media ",
    "\n"])), function (props) { return props.theme && styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", " {\n        font-size: ", ";\n    }"], ["\n    ", " {\n        font-size: ", ";\n    }"])), props.theme.DeviceQueries.Desktop, props.theme.Spacing["4"]); }, function (props) { return props.theme && styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", " {\n        font-size: ", ";\n    }"], ["\n    ", " {\n        font-size: ", ";\n    }"])), props.theme.DeviceQueries.LaptopL, props.theme.Spacing["3.5"]); }, function (props) { return props.theme && styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", " {\n        font-size: ", ";\n    }"], ["\n    ", " {\n        font-size: ", ";\n    }"])), props.theme.DeviceQueries.MobileL, props.theme.Spacing["3"]); });
var GetButton = function (blok) {
    if (blok.ButtonLink) {
        return (React.createElement(Button_1.Button, { href: blok.ButtonLink.cached_url }, blok.ButtonText));
    }
    else {
        return React.createElement(React.Fragment, null);
    }
};
exports.TextMetroTile = function (props) {
    var blok = props.blok;
    return (React.createElement(MetroTileWrapper, { textColor: blok.textColor, backgroundColor: blok.backgroundColor.color, gradientColor: blok.gradientColor.color, width: [1, 1 / 2] },
        React.createElement(Text, { dangerouslySetInnerHTML: { __html: marked_1["default"](blok.text) } }),
        GetButton(props.blok)));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
